import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Subaward PI: The association(s) between principal investigator (PI) and subaward. A PI may oversee multiple subawards or share a subaward with other PIs.',
    name: 'Subaward PIs',
    partialId: PartialId.Standard.create('subaward_pis'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
